// DepositSelfEmployed.tsx
import React, { useState, useEffect } from "react";
import BasicTable from '../../CustomTable';
import { ApprovalsApi } from "../../../api/Approvals";
import { PopupService } from "../../Macros/Popup";


const headerColumns = [
  { header: 'מספר חשבון' },
  { header: 'תאריך ערך הפקדה' },
  { header: 'סוג קופה' },
  { header: 'סכום פעולה' }
];

const DepositSelfEmployed = ({
  isDisplayMessage,
  isShow
}) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [actions, setActions] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pdfFile, setPdfFile] = useState(null);
  const [selectedIndex, setSelectedIndex]= useState([]);
  const [checkIsclicked, setCheckIsclicked] = useState(false)

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  }

  useEffect(()=>{
    if(checkIsclicked){
      scrollToBottom()
    }
  },[checkIsclicked])

  const handleDownload = () => {
    if (pdfFile) {
      const newTab = window.open('about:blank', '_blank');
      const url = URL.createObjectURL(pdfFile);
      if (newTab) {
        newTab.location.href = url;
      }
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      setPdfFile(null)
    }
  };

  const renderSuccessMessage = () => (
    <div>
      <div id="collapseFilter" className="collapse filter-block__collapse show">
        <div className="data-filter__row">
          <div className="data-filter__inputs">
            <div className="data-filter__inputs-row">
              <div className="col-auto data-filter__col">
                {"בקשתך התקבלה. האישור יוצג באזור האישי ב- \"דואר שלי\" תוך זמן קצר. במועד הפקת האישור, ישלח SMS למספר הטלפון הנייד המעודכן בילין לפידות"}
              </div>
            </div>
            {pdfFile && (
              <div className="col-auto main-dashboard__btn-col">
                <button
                  type="button"
                  className="main-dashboard__btn"
                  onClick={handleDownload}
                >
                  לצפיה והורדה לחץ כאן
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  const fetchData = async (page = 1) => {
    setIsLoading(true);
    const currentDate = new Date();
    const previousYear = currentDate.getFullYear() - 1;
    const previousYearDate = new Date(previousYear, 0, 1);

    try {
      const response = await ApprovalsApi.getDepositData({
        accountId: null,
        fromDate: previousYearDate,
        pageNo: page,
        pageSize: 20,
      });
      setActions(response.transactions);
      setTotalPages(response.totalPages);
    } catch (error) {
      console.error('Error fetching deposit data:', error);
      setActions([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCheckboxChange = (id, index) => {


    setSelectedIndex(prevIndex => {
      let newSelectedIndex;
      
      if (prevIndex?.includes(index)) {
        setCheckIsclicked(false);
        newSelectedIndex = prevIndex.filter(idx => idx !== index);
      } else {
        if (selectedIndex?.length < 5) {
          newSelectedIndex = [...prevIndex, index];
        } else {
          newSelectedIndex = prevIndex;
        }
      }
      
      return newSelectedIndex;
    });


    if(selectedIndex?.length < 5 ){

     
   
      setSelectedIds(prevIds => {
        const newSelectedIds = prevIds.includes(id)
          ? prevIds.filter(item => item !== id)
          : [...prevIds, id];
        return newSelectedIds;
      });
      setPdfFile(null)
    };
    }
 


  const createDepositLetter = async () => {
    setIsLoading(true);

    try {
      const res = await ApprovalsApi.createNewDeposit({
        letterTypeId: 91,
        transactionIds: selectedIndex
      });

      isDisplayMessage(true);

      if (res.size > 0) {
        const file = new Blob([res], { type: 'application/pdf' });
        setPdfFile(file);
      }
    } catch (error) {
      PopupService.alert('שגיאה', 'חלה תקלה, אנא נסו שנית מאוחר יותר', () => { });
    } finally {
      setIsLoading(false);
      setSelectedIds([]);
    }
  };

  const handlePaging = (page) => {
    setCurrentPage(page);
  };

  const relevantData = actions.map(item => ({
    accountNumber: item.accountNumber,
    valueDate: item.valueDate,
    fundName: item.fundName,
    totalAmount: item.totalAmount,
    id: item.transactionId,
    unipueId: item.id,
  }));

  if (isShow) {
    return renderSuccessMessage();
  }

  if (isLoading) {
    return (
      <div style={{ textAlign: "center", paddingTop: "2em" }}>
        <img src="/img/loading.gif" alt="loading" />
      </div>
    );
  }


  return (
    <>
      <div className="desc-view">
        <BasicTable
          headerColumns={headerColumns}
          data={relevantData}
          showWhite
          notShowIcon
          isShowCheckbox
          handleCheckboxChange={handleCheckboxChange}
          isCheckedBefor={selectedIndex}
          totalCount={totalPages}
          paging={handlePaging}
          currentPage={currentPage}
          counter={ selectedIndex?.length == 5 ? true : false}
          checkClick={setCheckIsclicked}
          
        />
         {
          checkIsclicked &&
          <div style={{color:'red'}}>
            שים לב, ניתן להפיק עד 5 אישורים
          </div>
        }
      </div>
      <div className="mobile-view">
        <BasicTable
          headerColumns={headerColumns}
          data={relevantData}
          showWhite
          notShowIcon
          isShowCheckboxMobile
          handleCheckboxChange={handleCheckboxChange}
          totalCount={totalPages}
          paging={handlePaging}
          counter={ selectedIndex?.length == 5 ? true : false}
          checkClick={setCheckIsclicked}
          checkForColor={selectedIndex}
          isCheckedBefor={selectedIndex}
          currentPage={currentPage}

        />
        {
          checkIsclicked &&
          <div style={{color:'red'}}>
            שים לב, ניתן להפיק עד 5 אישורים
          </div>
        }
      </div>

      <div className="data-filter__buttons">
        <div className="data-filter__buttons-row">
          <div className="col-auto data-filter__buttons-col">
            <button
              disabled={selectedIndex.length === 0}
              type="button"
              className={`data-filter__btn ${selectedIndex.length === 0 ? 'disableButton' : ''}`}
              onClick={createDepositLetter}
            >
              שלח
            </button>
          </div>
        </div>
      </div>

      <style>
        {`
          @media (max-width:991px) { .desc-view{display:none !important} }
          @media (min-width:991px) { .mobile-view{display:none !important} }
        `}
      </style>
    </>
  );
};

export default DepositSelfEmployed;